export default __webpack_public_path__ + "static/media/hitch_implement_B.45603e37.svg";